import { render, staticRenderFns } from "./EditorHeaderPresentationName.vue?vue&type=template&id=66f554fc&scoped=true"
import script from "./EditorHeaderPresentationName.vue?vue&type=script&lang=js"
export * from "./EditorHeaderPresentationName.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderPresentationName.vue?vue&type=style&index=0&id=66f554fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f554fc",
  null
  
)

export default component.exports